import { useCallback } from 'react';

import {
  useEarningMechanismUpdateMutation,
  OfferFragment,
  PromocodesOfferType,
} from '@occc/graphql';
import { useMutation } from '@occc-app/dataAccessLayer/utils';

import { makePromocodesCodesTypeUpdateOperation } from '../components/PromocodesTargetConfiguration/promocodes-target.operations';

export const useSavePromocodesCodesType = () => {
  const [updateEarningMechanism] = useMutation(useEarningMechanismUpdateMutation);

  const saveCodesType = useCallback(
    async (offer: OfferFragment | null | undefined, nextCodesType: PromocodesOfferType) => {
      const earningMechanism = offer?.earningMechanism;

      if (
        earningMechanism?.__typename !== 'EarningMechanismPromocodes' ||
        earningMechanism.codesType === nextCodesType
      ) {
        return;
      }

      const operation = makePromocodesCodesTypeUpdateOperation(offer ?? undefined, nextCodesType);

      if (!operation) {
        return;
      }

      await updateEarningMechanism({ variables: operation.variables });
    },
    [updateEarningMechanism],
  );

  return saveCodesType;
};
